import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../styles/site.css";

const PHONE = "+919121943442";
const PHONE_LABEL = "+91 91219 43442";
const EMAIL = "indianodysseyofficial@gmail.com";

const ContactPage = () => {
  const address =
    "3-501, Sarpavaram Main Rd, Sarpavaram, Kakinada, Andhra Pradesh 533005";
  const mapsQuery = encodeURIComponent(`Indian Odyssey, ${address}`);
  const mapsLink = `https://www.google.com/maps/search/?api=1&query=${mapsQuery}`;
  const mapsEmbed = `https://www.google.com/maps?q=${mapsQuery}&output=embed`;

  return (
    <section className="site-contact" id="contact">
      <div className="container">
        <div className="site-section-head">
          <h2>Contact Us</h2>
          <p>We'd love to hear from you</p>
        </div>
        <div className="site-contact-grid">
          <div className="site-contact-info">
            <div>
              <a href={`tel:${PHONE}`} className="site-contact-action">
                <span className="site-contact-icon is-call"><i className="bi bi-telephone" aria-hidden="true" /></span>
                <span><small>Call us</small><strong>{PHONE_LABEL}</strong></span>
                <i className="bi bi-chevron-right" aria-hidden="true" />
              </a>
              <a
                href={`https://wa.me/${PHONE.replace("+", "")}`}
                target="_blank"
                rel="noreferrer"
                className="site-contact-action"
              >
                <span className="site-contact-icon is-whatsapp"><i className="bi bi-whatsapp" aria-hidden="true" /></span>
                <span><small>WhatsApp</small><strong>Chat with us</strong></span>
                <i className="bi bi-chevron-right" aria-hidden="true" />
              </a>
              <a href={`mailto:${EMAIL}`} className="site-contact-action">
                <span className="site-contact-icon is-mail"><i className="bi bi-envelope" aria-hidden="true" /></span>
                <span><small>Email</small><strong>{EMAIL}</strong></span>
                <i className="bi bi-chevron-right" aria-hidden="true" />
              </a>
            </div>

            <div className="site-contact-office">
              <div className="site-contact-label">Main office</div>
              <address>{address}</address>
              <div className="site-contact-links">
                <a href={mapsLink} target="_blank" rel="noreferrer">
                  <i className="bi bi-geo-alt" aria-hidden="true" /> Open in Google Maps
                </a>
                <a href="https://www.instagram.com/indianodyssey.in" target="_blank" rel="noreferrer">
                  <i className="bi bi-instagram" aria-hidden="true" /> Instagram
                </a>
                <a href="https://www.google.com/search?q=Indian+Odyssey+Kakinada" target="_blank" rel="noreferrer">
                  <i className="bi bi-google" aria-hidden="true" /> Google
                </a>
              </div>
            </div>
          </div>

          <div className="site-contact-map">
            <iframe
              title="Indian Odyssey office on Google Maps"
              src={mapsEmbed}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
